import {FieldMap, FieldOperations, OpsCategories, SqlOperation, TableI} from "../Types";
import {nanoid} from "@reduxjs/toolkit";
import {GREEN_COLOR, GREEN_LIGHT_COLOR, RED_COLOR, SELECT_BACK_COLOR, YELLOW_COLOR} from "../components/CONSTANTS";


const inmsgStatusMap = {
    groups: [
        {
            label: {
                ua: "Коректні",
            },
            values: ["OK"]
        },
        {
            label: {
                ua: "Невідомо",
            },
            values: ["UNKNOWN", "NEW"]
        },
        {
            label: {
                ua: "Некоректні",
            },
            values: ["DUPLICATE", "BAD_QUALITY", "DO_NOT_MATCH", "OTHER"]
        }],
    //backgroundColor: '#18111c',
    backgroundColor: SELECT_BACK_COLOR,
    values: {
        "OK": {
            rawValue: "OK",
            lang: {
                ua: "ОК",
            },
            color: GREEN_COLOR
        },
        "UNKNOWN": {
            rawValue: "UNKNOWN",
            lang: {
                ua: "Невідомий",
            },
            color: YELLOW_COLOR
        },
        "NEW": {
            rawValue: "NEW",
            lang: {
                ua: "Новий",
            },
            color: GREEN_LIGHT_COLOR
        },
        "DO_NOT_MATCH": {
            rawValue: "DO_NOT_MATCH",
            lang: {
                ua: "Не відповідає умовам",
            },
            color: RED_COLOR
        },
        "DUPLICATE": {
            rawValue: "DUPLICATE",
            lang: {
                ua: "Дублікат",
            },
            color: "#ee8517"
        },
        "BAD_QUALITY": {
            rawValue: "BAD_QUALITY",
            lang: {
                ua: "Погана якість",
            },
            color: RED_COLOR
        },
        "OTHER": {
            rawValue: "OTHER",
            lang: {
                ua: "Інше",
            },
            color: RED_COLOR
        },
    }
} as FieldMap;


let fieldOperations: FieldOperations = {
    status: [...OpsCategories.in],
    shop: [...OpsCategories.like],
    msisdn: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    email: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    date: [...OpsCategories.range],
    prize: [...OpsCategories.null, ...OpsCategories.like],
    unique_id: [...OpsCategories.eq, ...OpsCategories.null],
    device: [...OpsCategories.like],
    os: [...OpsCategories.like],
    ip: [...OpsCategories.eq],
    dt: [...OpsCategories.range],
    count_reg: [...OpsCategories.range],
    qr_code: [...OpsCategories.null],
    id: [...OpsCategories.eq, ...OpsCategories.range, ...OpsCategories.in,],
};
export const ImnsgTable: TableI = {
    backend: "/342/",
    title: {
        ua: "Реєстрації",
        en: "Замовлення",
    },
    pk: 'id',
    defaultOrderedBy: "dt",
    defaultOrderedWay: "ASC",
    defaultPerPage: 20,
    orderByFields: {
        "id": {ua: "ID", en: "№"},
        "dt": {ua: "Створено", ru: "Дата"},
        "count_reg": {ua: "Кількість реєстрацій", ru: "Дата"},
        "date": {ua: "Дата", ru: "Дата"},
    },
    fieldOperations: fieldOperations,
    defaultFilters: 'inmsg342DefFilters',
    fields: [
        {
            key: "n",
            inline: true,
            title: {ua: "№"}, type: "number",
            applyTransform: true
        },
        {
            key: "dt",
            title: {ua: "Створено"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            detailed: false,
            inline: true,
        },
        {
            key: "msisdn", type: 'tel',
            editable: true,
            applyTransform: true,
            detailed: true, inline: true, title: {ua: "Телефон"}
        },
        {
            key: "first_name", type: 'string',
            editable: true,
            applyTransform: true,
            detailed: true, inline: true, title: {ua: "Ім'я"}
        },
        {
            key: "last_name", type: 'string',
            editable: true,
            applyTransform: true,
            detailed: true, inline: true, title: {ua: "Прізвище"}
        },
        {
            key: "email", type: 'email',
            editable: true,
            applyTransform: true,
            detailed: true, inline: true, title: {ua: "Email"}
        },
        {
            key: "date", type: 'date',
            editable: true,
            applyTransform: true,
            datetimeFormat: "DD MMMM",
            detailed: true, inline: true, title: {ua: "Дата"}
        },

        {
            key: "status", type: 'map',
            map: inmsgStatusMap,
            applyTransform: true,
            editable: true,
            detailed: true,
            inline: true,
            title: {ua: "Статус"}
        },
        {
            key: "unique_id",
            detailed: true,
            title: {ua: "Унікальний ідентифікатор"},
            type: 'string',
            editable: true,
            updateSingleFieldPath: 'updateUniqueId.php',
            comment: 'ФН чека (пробіл) ФН ПРРО',
            getColumnValue: "uniqueId342Qr",
            applyTransform: true,
            nullable: true
        },
        {
            key: "check_photo",
            detailed: true,
            title: {ua: "Чек"},
            type: 'image',
            applyTransform: true,
            imageMaxHeight: 450,
            imageMaxWidth: 550
        },
        {
            key: "qr_code",
            detailed: true,
            editable: true,
            nullable: true,
            title: {ua: "QR"},
            type: 'url',
            applyTransform: true
        },
        {
            key: "count_reg", type: 'number',
            applyTransform: true,
            detailed: true, inline: true, title: {ua: "Кількість реєстрацій"}
        },
        {
            key: "shop", type: 'string',
            editable: true,
            applyTransform: true,
            detailed: true, inline: true, title: {ua: "Магазин"}
        },
        {
            key: "comment", title: {ua: "Коментар"}, type: 'string',
            editable: true, nullable: true,
            applyTransform: true
        },
        {
            key: "prize", title: {ua: "Приз"}, type: 'string',
            editable: true, nullable: true,
            applyTransform: true
        },
        {
            key: "ip", title: {ua: "IP"}, type: 'string', detailed: true, inline: false
        },
        {
            key: "os", title: {ua: "ОС"}, type: 'string', detailed: true, inline: false
        },
        {
            key: "device", title: {ua: "Девайс"}, type: 'string', detailed: true, inline: false
        },
        {
            key: "id",
            detailed: true,
            title: {ua: "ID"},
            type: "number",
            applyTransform: true
        },
    ]
}

export function inmsg342DefFilters() {
    return [
        // {
        //     nanoid: nanoid(),
        //     field: 'msisdn',
        //     type: 'tel',
        //     filterOp: SqlOperation.LIKE,
        //     locked: true,
        //     value: ''
        // },
        {
            nanoid: nanoid(),
            field: 'status',
            type: 'map',
            filterOp: SqlOperation.IN,
            locked: true,
            value: ['NEW', 'UNKNOWN']
        }
    ]
}
